﻿import { connect } from 'react-redux'

// lib 
import { motion, AnimatePresence } from 'framer-motion';

// components
import CloseDialog from './CloseDialog'
import StopDialog from './StopDialog'

// utils
import * as constants from '../../Utils/constants';


const Modal = ( props ) => {

    return (
        <AnimatePresence>
                <motion.div
                    className="pension-wizard-block__modal"
                    initial={{
                        opacity: 0,
                        scale: 0.75,
                    }}
                    animate={{
                        opacity: 1,
                        scale: 1,
                        transition: {
                            ease: "easeOut",
                            duration: 0.15,
                        },
                    }}
                    exit={{
                        opacity: 0,
                        scale: 0.75,
                        transition: {
                            ease: "easeIn",
                            duration: 0.15,
                        },
                    }}
            >
                <div className="pension-wizard-block__question">

                    {props.content === 'CLOSE' && (
                        <CloseDialog
                            headline={constants.closeDialog.headline}
                            text={constants.closeDialog.text}
                        />
                    )}

                    {props.content === 'STOP' && (
                        <StopDialog
                            headline={constants.stopDialog.headline}
                            text={constants.stopDialog.text}
                        />
                    )}
                </div>
           </motion.div>
           
        </AnimatePresence>
     )
}

const mapStateToProps = (state) => {
    return {
        content: state.pensionWizardModal.modalContent
    };
};

export default connect(mapStateToProps, null)(Modal);

